import {
  Component,
  ComponentInterface,
  getAssetPath,
  h,
  Prop,
} from '@stencil/core';
import { InterfacePafIcon } from './paf-icon.custom';

import { iconVariantPaths } from '../../assets/timetable-icons.config';

@Component({
  assetsDirs: ['build/assets'],
  shadow: true,
  styleUrl: 'paf-icon.scss',
  tag: 'paf-icon',
})

export class PafIcon implements ComponentInterface {

  /**
   * The variant property will set a CSS class with the
   * same name, which will set the aspect-ratio and some
   * other styling, if needed.
   */
  @Prop() public variant?: InterfacePafIcon['variant'];

  /**
   * The name has to match any of the timetable related
   * icon names from https://icons.app.sbb.ch/
   */
  @Prop() public name!: string;

  public render(): HTMLDivElement {
    const imageSrc = getAssetPath(`../assets/timetable-icons/${iconVariantPaths[this.variant]}/${this.name}.svg`);

    if (this.name === undefined) {
      return null;
    }

    return (
      <img
        alt=''
        class={this.variant}
        decoding='async'
        loading='lazy'
        src={imageSrc}
        data-testid='image'
      />
    );
  }
}
